import { subscribe } from '../../../common/errors/sagas';
import { notificationError } from '../../../common/errors/notificationTypes';

const pre = 'WEBJOBS/';

export const SET_DEFAULT_FILTERS = `${pre}SET_DEFAULT_FILTERS`;
export const SET_LOADING = `${pre}SET_LOADING`;
export const SET_INITIALISED = `${pre}SET_INITIALISED`;
export const WEB_JOBS_LOADED = `${pre}WEB_JOBS_LOADED`;
export const LOAD_REQUEST_OPENED = `${pre}LOAD_REQUEST_OPENED`;
export const FETCH_LOAD_REQUEST_OPTIONS_FAILED = `${pre}FETCH_LOAD_REQUEST_OPTIONS_FAILED`;
export const CREATE_LOAD_REQUEST = `${pre}CREATE_LOAD_REQUEST`;
export const CREATE_LOAD_REQUEST_FAILED = `${pre}CREATE_LOAD_REQUEST_FAILED`;
export const SET_ROWS = `${pre}SET_ROWS`;
export const FETCH_DATA_LOADS_FAILED = `${pre}FETCH_DATA_LOADS_FAILED`;
export const SET_ROW_CHECKED = `${pre}SET_ROW_CHECKED`;
export const SET_ALL_ROWS_CHECKED = `${pre}SET_ALL_ROWS_CHECKED`;
export const SET_DETAILS_BEING_VEIWED = `${pre}SET_DETAILS_BEING_VEIWED`;
export const RERUN_SELECTED_ROWS = `${pre}RERUN_SELECTED_ROWS`;
export const RERUN_SELECTED_ROWS_FAILED = `${pre}RERUN_SELECTED_ROWS_FAILED`;
export const SET_LOAD_REQUEST_MAPPINGS = `${pre}SET_LOAD_REQUEST_MAPPINGS`;
export const REFRESH_DATA = `${pre}REFRESH_DATA`;
export const SET_GRID_SORTS = `${pre}SET_GRID_SORTS`;
export const SET_ALL_GRID_SORTS = `${pre}SET_ALL_GRID_SORTS`;
export const REFRESH_WEB_JOBS_DATA_LOADS = `${pre}REFRESH_WEB_JOBS_DATA_LOADS`;

subscribe(FETCH_LOAD_REQUEST_OPTIONS_FAILED, 'Failed to fetch load request options', notificationError);
subscribe(CREATE_LOAD_REQUEST_FAILED, 'Failed to create a new load request', notificationError);
subscribe(FETCH_DATA_LOADS_FAILED, 'Failed to fetch data loads', notificationError);
subscribe(RERUN_SELECTED_ROWS_FAILED, 'Failed to rerun selected rows', notificationError);

export const refreshWebJobsDataLoads = () => ({
    type: REFRESH_WEB_JOBS_DATA_LOADS
});

export const setAllGridSorts = data => ({
    type: SET_ALL_GRID_SORTS,
    data
});

export const setGridSorts = (gridId, sorting) => ({
    type: SET_GRID_SORTS,
    gridId,
    sorting
});

export const setLoadRequestMappings = mappings => ({
    type: SET_LOAD_REQUEST_MAPPINGS,
    mappings
});

export const rerunSelectedRowsFailed = error => ({
    type: RERUN_SELECTED_ROWS_FAILED,
    error
});

export const rerunSelectedRows = rows => ({
    type: RERUN_SELECTED_ROWS,
    rows
});

export const setRowChecked = (id, checked) => ({
    type: SET_ROW_CHECKED,
    id,
    checked
});

export const setAllRowsChecked = checked => ({
    type: SET_ALL_ROWS_CHECKED,
    checked
});

export const createLoadRequest = (sourceType, category, date, endDate /*, unsegMode*/) => ({
    type: CREATE_LOAD_REQUEST,
    sourceType,
    category,
    date,
    endDate/*,
    unsegMode */    
});

export const setDetailsBeingViewed = details => ({
    type: SET_DETAILS_BEING_VEIWED,
    details
});

export const setRows = (rows, serverFilters) => ({
    type: SET_ROWS,
    rows,
    serverFilters
});

export const fetchDataLoadsFailed = error => ({
    type: FETCH_DATA_LOADS_FAILED,
    error
});

export const createLoadRequestFailed = error => ({
    type: CREATE_LOAD_REQUEST_FAILED,
    error
});

export const fetchLoadRequestOptionsFailed = error => ({
    type: FETCH_LOAD_REQUEST_OPTIONS_FAILED,
    error
});

export const loadRequestOpened = () => ({
    type: LOAD_REQUEST_OPENED
});

export const setDefaultFilters = filters => ({
    type: SET_DEFAULT_FILTERS,
    filters
});

export const setInitialised = initialised => ({
    type: SET_INITIALISED,
    initialised
});

export const webJobsLoaded = search => ({
    type: WEB_JOBS_LOADED,
    search
});

export const setLoading = loading => ({
    type: SET_LOADING,
    loading
});

export const refreshData = () => ({
    type: REFRESH_DATA
});
